"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseTwinControl from "D5Utils/form_fields/BaseTwinControl";
import { System } from "Constants/objects";

var NumberTwinControl =
/*#__PURE__*/
function (_BaseTwinControl) {
  _inherits(NumberTwinControl, _BaseTwinControl);

  function NumberTwinControl() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NumberTwinControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NumberTwinControl)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_type", System.DX_CONTROLS.dxNumberBox);

    return _this;
  }

  _createClass(NumberTwinControl, [{
    key: "_buildControlProps",
    value: function _buildControlProps(data) {
      var _this2 = this;

      return _objectSpread({}, _get(_getPrototypeOf(NumberTwinControl.prototype), "_buildControlProps", this).call(this, data), {
        format: this.props.format,
        onValueChanged: function onValueChanged(e) {
          _this2.$fieldFrom.attr('data-from', e.value);

          var from = e.value != null ? Number(e.value) : undefined;
          var to = e.element.attr('data-to') != null ? Number(e.element.attr('data-to')) : undefined;
          _this2.value = [from, to];

          if (typeof _this2.props.onValueChanged === 'function') {
            _this2.props.onValueChanged({
              value: _this2.value
            });
          }
        }
      });
    }
  }, {
    key: "_buildControlToProps",
    value: function _buildControlToProps() {
      var _this3 = this;

      return _objectSpread({}, _get(_getPrototypeOf(NumberTwinControl.prototype), "_buildControlToProps", this).call(this), {
        format: this.props.format,
        onValueChanged: function onValueChanged(e) {
          _this3.$fieldFrom.attr('data-to', e.value);

          var from = _this3.$fieldFrom.attr('data-from') != null ? Number(_this3.$fieldFrom.attr('data-from')) : undefined;
          var to = e.value != null ? Number(e.value) : undefined;
          _this3.value = [from, to];

          if (typeof _this3.props.onValueChanged === 'function') {
            _this3.props.onValueChanged({
              value: _this3.value
            });
          }
        }
      });
    }
  }, {
    key: "_comparisonTarget",
    value: function _comparisonTarget(options) {
      // let instance = this.$fieldFrom[this._type]("instance");
      // if (instance) {
      //     let value = instance.option("value");
      //     return (value == null && options.value == null) || (value <= options.value);
      // }
      return true;
    }
  }]);

  return NumberTwinControl;
}(BaseTwinControl);

export { NumberTwinControl as default };